export default __webpack_public_path__ + "static/media/sharpT.58e4e0fe.png";